import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import fetchBook from "../redux/books/thunk/fetchBooks";

import Book from "./Book";

const BookList = () => {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state.books);
  const { status, search } = useSelector((state) => state.filters);

  const filterBySearch = (book) => { return book.name.toLowerCase().includes(search.toLowerCase()); };
  const filterByStatus = (book) => { return status === "showAll" ? true : book.featured; };

  useEffect(() => { dispatch(fetchBook); }, [dispatch]);

  const bookList = books.filter(filterByStatus).filter(filterBySearch);

  if (!bookList.length) return <div>No Book Found!</div>;

  return (
    <div className="lws-bookContainer">
      {books.filter(filterByStatus).filter(filterBySearch).map((book) => (<Book key={book.id} book={book} />))}
    </div>
  );
};

export default BookList;
